import { z } from 'zod';

export const LOAModalSchema = z.object({
  attachments: z.array(z.instanceof(File)).optional(),
  contact_name: z.string().trim().nonempty('Required'),
  signature: z.string().trim().nonempty('Required'),
});
export type LOAModalForm = z.infer<typeof LOAModalSchema>;
